import { render, staticRenderFns } from "./RunnitTokens.vue?vue&type=template&id=39b059a2&scoped=true"
import script from "./RunnitTokens.vue?vue&type=script&lang=ts"
export * from "./RunnitTokens.vue?vue&type=script&lang=ts"
import style0 from "./RunnitTokens.vue?vue&type=style&index=0&id=39b059a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b059a2",
  null
  
)

export default component.exports